export class WebPage {
    WebPageID: number;
    AvailableDate: Date;
    WebPageParentID: number;
    DisplayID: number;
    Priority: number;
    WebPageTranslations: Array<WebPageTranslation> = [];
}

export class WebPageTranslation {
    WebPageID: number;
    LanguageID: number;
    LanguageText: string;
    Title: string;
    TitleParent: string;
    ShortDescription: string;
    Description: string;
    TitleReferencement: string;
    DescriptionReferencement: string;
    URL: string;
}